import {
  Content,
  Page,
  Row,
} from '@trufla-technology/trumarket-react-design-system';
export const Reports = () => {
  return (
    <Content>
      <Page>
        <h1>Reports</h1>
        <Row>
          <p>Welcome to the truAdmin Reports!</p>
        </Row>
      </Page>
    </Content>
  );
};
